import { LandingSection } from "./HomeSections/Landing.js"
import './CSS/Critical.css';
//import React, { Suspense } from "react";

//const AboutMe = () => React.lazy(() => import('./HomeSections/AboutMe'))
//const Skills = () => React.lazy(() => import('./HomeSections/Skills.js'))
//const Education = () => React.lazy(() => import('./HomeSections/Education.js'))
//const Certifications = () => React.lazy(() => import('./HomeSections/Certifications.js'))
//const Languages = () => React.lazy(() => import('./HomeSections/Languages.js'))
//const Contact = () => React.lazy(() => import('./HomeSections/Contact.js'))

import AboutMe from "./HomeSections/AboutMe";
import { SkillsSection } from "./HomeSections/Skills.js";
import { EducationSection } from "./HomeSections/Education.js";
import { CertificationsSection } from "./HomeSections/Certifications.js";
import { LanguagesSection } from "./HomeSections/Languages.js";

export const Home = () => {

    return (
        <div className="App">
            <LandingSection/>
            <AboutMe />
            <SkillsSection/>
            <EducationSection/>
            <CertificationsSection/>
            <LanguagesSection/>
        </div>
    )
}